import { useAppSelector } from 'core/store/hooks';
import { useState } from 'react';
import PopoverBody from './components/PopoverBody';
import PopoverComponent from './components/PopoverComponent';
import PopoverFooter from './components/PopoverFooter';
import PopoverHeader from './components/PopoverHeader';

const Filter = () => {
  const selectedSearchEngines = useAppSelector(
    (state) => state.sourceFilterV2.selectedSearchEngines
  );

  const [localFilters, setLocalFilters] = useState({
    searchEngines: selectedSearchEngines,
    sourceDate: null,
    publishedSince: null,
  });

  return (
    <PopoverComponent>
      <PopoverHeader setLocalFilters={setLocalFilters} />
      <PopoverBody localFilters={localFilters} setLocalFilters={setLocalFilters} />
      <PopoverFooter localFilters={localFilters} setLocalFilters={setLocalFilters} />
    </PopoverComponent>
  );
};

export default Filter;
